import { PageHero, SHELL, Reveal, Mono, Btn } from "@/components/bits";
import { PROOFS } from "@/lib/data";
import { ArrowUpRight, ShieldCheck } from "lucide-react";

export default function Proof() {
    return (
        <div data-testid="proof-page">
            <PageHero
                label="PROOF CENTER"
                title={"VERIFY THE THESIS"}
                sub="Explore the public documentation and official sources behind VERA's infrastructure thesis. Every claim on this website traces back to a source you can open yourself."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="grid md:grid-cols-2 gap-5 mb-20">
                        {PROOFS.map((p, i) => (
                            <Reveal key={p.id} delay={i * 0.05}>
                                <div className="glass-card p-7 md:p-8 h-full flex flex-col hover:border-vera-blue/40 transition-colors" data-testid={`proof-card-${p.id}`}>
                                    <div className="flex items-center justify-between mb-6">
                                        <Mono className="text-vera-gold2">{p.org}</Mono>
                                        <span className="font-mono text-[9px] tracking-[0.2em] text-vera-mut border border-white/15 px-2 py-0.5">{p.source}</span>
                                    </div>
                                    <h3 className="font-bold tracking-wide text-base sm:text-lg mb-4 leading-snug">{p.title}</h3>
                                    <p className="text-sm text-vera-mut leading-relaxed flex-1">{p.desc}</p>
                                    <div className="flex items-center justify-between mt-7 pt-5 border-t border-white/10">
                                        <span className="font-mono text-[9px] tracking-[0.2em] text-vera-mut/60">SOURCE — {p.source.toUpperCase()}</span>
                                        <a
                                            href={p.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid={`proof-verify-${p.id}`}
                                            className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-vera-gold2 hover:text-vera-gold border border-vera-gold/40 hover:border-vera-gold px-4 py-2.5 transition-all"
                                        >
                                            VERIFY <ArrowUpRight className="w-3.5 h-3.5" aria-hidden="true" />
                                        </a>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal>
                        <div className="border border-dashed border-vera-gold/40 bg-vera-gold/5 p-8 md:p-10" data-testid="partnership-verification-block">
                            <div className="flex items-center gap-3 mb-6">
                                <ShieldCheck className="w-5 h-5 text-vera-gold" aria-hidden="true" />
                                <Mono className="text-vera-gold2">OFFICIAL ECOSYSTEM & PARTNERSHIP PROOF</Mono>
                            </div>
                            <div className="grid lg:grid-cols-2 gap-8">
                                <div>
                                    <p className="font-mono text-[10px] tracking-[0.25em] text-vera-white mb-3">ECOSYSTEM ALIGNMENT</p>
                                    <p className="text-sm text-vera-mut leading-relaxed">
                                        VERA is building around the RWA and programmable-finance primitives supported by the Arc ecosystem — USDC
                                        settlement, Arc execution, and the launchpad and RWA infrastructure documented in the sources above.
                                    </p>
                                </div>
                                <div>
                                    <p className="font-mono text-[10px] tracking-[0.25em] text-vera-white mb-3">OFFICIAL PARTNERSHIP</p>
                                    <p className="text-sm text-vera-mut leading-relaxed">
                                        Partnership verification will be published here when an official source is available. Until then, VERA makes no
                                        partnership or endorsement claim — ecosystem alignment is not an official partnership.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="flex flex-wrap items-center justify-between gap-6 mt-16 border border-white/10 px-8 py-7" data-testid="proof-report-block">
                            <p className="text-vera-mut text-sm max-w-xl">
                                Is an official partnership document available? Send the official source URL through the VERA X account and it will be
                                verified and published here.
                            </p>
                            <Btn variant="ghost" to="/faq" testid="proof-faq-link" className="!px-5 !py-3">
                                READ THE FAQ
                            </Btn>
                        </div>
                    </Reveal>
                </SHELL>
            </section>
        </div>
    );
}
